import { Button } from "antd";

interface VendorsActionsProps {
  noBidReason: string | null;
  approvedByVendor: boolean;
  status: string;
  changePopover: () => void;
}

export default function VendorsActions({
  changePopover,
  status,
}: VendorsActionsProps) {
  if (status === "Pending") {
    return (
      <>
        <Button
          type="primary"
          htmlType="button"
          onClick={changePopover}
          className="h-10 bg-red-light text-red-main font-inter text-base font-semibold hover:!text-red-light hover:!bg-red-main transition"
        >
          No Bid
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          className="h-10 font-inter text-base font-semibold"
        >
          Submit
        </Button>
      </>
    );
  }

  return null;
}
